import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    content: [
      { label: '电影', to: '/category/dianying' },
      { label: '电视剧', to: '/category/dianshiju' },
      { label: '综艺', to: '/category/zongyi' },
      { label: '动漫', to: '/category/dongman' },
      { label: '纪录片', to: '/category/jilu' },
      { label: '体育', to: '/category/tiyu' },
      { label: '音乐', to: '/category/yinyue' },
      { label: '游戏', to: '/category/youxi' },
    ],
    about: [
      { label: '关于我们', to: '/about' },
      { label: '品牌介绍', to: '/about' },
      { label: '用户口碑', to: '/about#testimonials' },
      { label: '联系我们', to: '/about#contact' },
    ],
    support: [
      { label: '会员权益', to: '/about#membership' },
      { label: '常见问题', to: '/about#faq' },
      { label: '服务条款', to: '/about' },
      { label: '隐私政策', to: '/about' },
    ],
  };

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
                91天堂
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              正版资源全覆盖，极速加载，安全稳定。
              <br />
              每日更新高清内容，注册解锁会员专属权益。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.content.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-background-400 hover:text-primary-300 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">关于</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.to + link.label}>
                  <Link to={link.to} className="text-sm text-background-400 hover:text-primary-300 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">支持</h4>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.to + link.label}>
                  <Link to={link.to} className="text-sm text-background-400 hover:text-primary-300 transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-700">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {currentYear} 91天堂 版权所有 | 本站所有内容均为正版授权
            </p>
            <p className="text-xs text-background-500">
              安全稳定访问 | 极速加载体验 | 正版资源全覆盖
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}